// Colunas do grid.
export const Columns = [
	{
		headerName: 'name',
		field: 'name',
		filter: true
	},
	{
		headerName: 'card_flag_credit_fee_percentage',
		field: 'creditFeePercentage',
		type: 'percentage',
		width: 220
	},
	{
		headerName: 'card_flag_debit_fee_percentage',
		field: 'debitFeePercentage',
		type: 'percentage'
	},
	{
		headerName: 'card_flag_pix_fee_percentage',
		field: 'pixFeePercentage',
		type: 'percentage'
	},
	{
		headerName: 'status',
		field: 'status',
		type: 'trans'
	}
]